/**
 * Modo rascunho.
 *
 * Ligado, a página mostra os buracos: valores em aberto ficam marcados e os
 * blocos sem texto exibem a marginalia de obra. É como o grupo enxerga o que
 * falta.
 *
 * Desligado, a página some com tudo isso: linha sem dado não aparece, bloco
 * sem texto não aparece. É como o visitante enxerga em outubro. Uma ficha com
 * quatro linhas dizendo "a confirmar" passa a mesma impressão de curso
 * improvisado que motivou o grupo a assumir a divulgação.
 *
 * Para gerar a versão pública: VITE_RASCUNHO=false npm run build
 */
export const RASCUNHO = import.meta.env['VITE_RASCUNHO'] !== 'false';
